export default {
      id: "ic_attention_orange-usage",
      viewBox: "0 0 20 19",
      url: "/" + "images/icons.3.109.2.svg#ic_attention_orange-usage",
      toString: function () {
        return this.url;
      }
    }